export function formatAuditTime(value: string) {
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return value;
  return date.toLocaleString(undefined, { dateStyle: "medium", timeStyle: "short" });
}

export function modelLabel(thread: { model: string; model_name?: string | null }) {
  return thread.model_name || thread.model;
}
